









































































































import { CreateElement, VNode } from 'vue';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Model, Prop, Component } from 'vue-property-decorator';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select/types';
import { DropdownDirValues, dropdown } from '../dropdown-main';
import { CSSStyleOptions } from '@sonicwall/unified-ui-framework/src/shared/common-types';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import DropdownLightUnit from './dropdown-light-unit.vue';
import { SwSelect } from '@libs-uuif/shared/sw-select';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';

const cssPrefix = 'dropdown-light';

@Component({
  directives:{
    dropdown,
  },
  components:{
    SwIcon,
    SwSelect,
    SwCheckbox,
    DropdownLightUnit,
  },
})
export default class DropdownLight extends SwExtendedVue{

  @Model('change', { type: [Array, String], required: true })
  value: string | string[];

  @Prop({ type: Boolean, default: false })
  disabled: boolean;

  @Prop({ type: Array, required: true })
  options: SelectOption[];

  @Prop({ type: String, required: true })
  name: string;

  @Prop({ type: Boolean, default: false })
  full: boolean;

  @Prop({ default: 'default' })
  type: 'default' | 'threedotsmenu' | 'checkboxmenu' | string;

  @Prop({ type: Boolean, default: undefined })
  someotherElement: boolean;

  @Prop({ type: Boolean, default: undefined })
  checkboxmenu: boolean;

  @Prop({ type: String, default: '' })
  checkboxmenuLabel: string;

  @Prop({ type: Number, default: 180 })
  dropdownWidth: number;

  @Prop({ type: String, default: 'light' })
  theme: 'light' | 'dark';

  hunger: string = 'Hunger text';
  isFocus: boolean = false;
  cssPrefix = cssPrefix;
  isDropdownVisible: boolean = false;
  selectedValues: string | string[] = '';
  scopeId = String(Math.floor(Math.random() * 100000000000));
  dropdownContainerHeight: any = '0px';
  productsFilterSelected:string[] = [];

  get divStyle(): CSSStyleOptions {
    return {
      width: '100px',
      height: '30px',
    };
  }

  get selectedOptions(): SelectOption[] {
    return this.options.filter((option) => {
      return this.value === option.id;
    });
  }

  get optionsDropdownValue(): DropdownDirValues {
    return {
      withArrow: false,
      content: this.optionsDropdownRows,
      trigger: 'controlled',
      visible: !this.disabled && this.isDropdownVisible,
      placement: this.rightOrBottom() ?  'right-start' : 'bottom-end',
      width: this.dropdownWidth,
      maxWidth: this.dropdownWidth,
      onClickOutsidePopper: () => { this.isDropdownVisible = false; },
      customClasses: [this.theme === 'dark' ? 'sw-dropdown_dropdown-light--dark' : 'sw-dropdown_dropdown-light'],
    };
  }

  get checkboxOptionsDropdownValue(): DropdownDirValues {
    return {
      withArrow: false,
      content: this.renderCheckboxMenu,
      trigger: 'controlled',
      visible: !this.disabled && this.isDropdownVisible,
      placement: 'bottom-end',
      width: this.dropdownWidth,
      maxWidth: this.dropdownWidth,
      onClickOutsidePopper: () => { this.isDropdownVisible = false; },
      customClasses: [this.theme === 'dark' ? 'sw-dropdown_dropdown-light--dark' : 'sw-dropdown_dropdown-light'],
    };
  }

  rightOrBottom(): boolean {
    return (this.type !== 'default' && !this.someotherElement) || (this.type === 'default' && this.someotherElement);
  }

  // tslint:disable-next-line:no-unused
  optionsDropdownRows(h: CreateElement): VNode[] {
    const nodes: VNode[] = [];
    // const bigNode: VNode[] = [];
    this.options.forEach((option) => {
      const isSelected = this.selectedOptions.findIndex(o => (o.id === option.id)) >= 0;
      let node = (<div></div>) as VNode;
      if (this.type === 'ThreeDotsMenu') {
        node = (
          <DropdownLightUnit
            key = { option.id }
            // tslint:disable-next-line:align
            // tslint:disable-next-line:brace-style
            // tslint:disable-next-line:ter-indent
            id = {`${this.cssPrefix}__option-${this.scopeId}-${option.id}`}
                           {...{ class: `${this.cssPrefix}__option-${this.scopeId}` }}
            props-selected = { isSelected }
            props-disabled = {option.id === ''}
            props-theme = { this.theme }
            nativeOn-click = {() => { this.onSelectOption(option); }} >

              {
                typeof option.label === 'function' ? option.label(h) : option.label
              }

          </DropdownLightUnit>
        ) as VNode;
      } else {
        node = (
          <DropdownLightUnit
            key = { option.id }
            // tslint:disable-next-line:align
            // tslint:disable-next-line:brace-style
            // tslint:disable-next-line:ter-indent
            id = {`${this.cssPrefix}__option-${this.scopeId}-${option.id}`}
                           {...{ class: `${this.cssPrefix}__option-${this.scopeId}` }}
            props-selected = { isSelected }
            props-disabled = {option.id === ''}
            props-theme = { this.theme }
            nativeOn-mousedown = {(e:any) => { this.onSelectOption(option, e); }} >

              {
                typeof option.label === 'function' ? option.label(h) : option.label
              }

          </DropdownLightUnit>
        ) as VNode;
      }
      // tslint:disable-next-line:ter-indent
      nodes.push(node);
    });
    return nodes;
  }

  optionsDropdownContent(h: CreateElement): VNode {
    let nodeHeight: any;
    // tslint:disable-next-line:one-variable-per-declaration
    const node: VNode = (
      // tslint:disable-next-line:max-line-length
      <div id="dropdowncontainer" ref="dropdown__container" class = { [`${this.cssPrefix}__container`, 'sw-flexbox__flex', { [`${cssPrefix}--dark`]: this.theme === 'dark' }] } >
        { this.optionsDropdownRows(h) }
      </div>
    ) as VNode;
    this.$nextTick(() => {
      // let dropdownContainerHeight = '0px';
      try {
        nodeHeight = document.getElementById('dropdowncontainer');
        this.dropdownContainerHeight = `${nodeHeight.clientHeight + 2}px`;
        (document.getElementsByClassName('sw-dropdown_dropdown-light')[0] as HTMLElement).style.height = this.dropdownContainerHeight;
      } catch (e) {
        console.warn('Kansas:: ', e);
      }
    });
    return node;
  }

  onSelectOption(option: SelectOption, e: any = undefined): any {
    try {
      if (e) {
        e.stopPropagation();
        e.preventDefault();
      }
      this.$emit('change', option.id);
      // (this.$el as HTMLElement).focus();
      // @ts-ignore
      if (!option['keepDropDownOpen']) this.isDropdownVisible = false;
    } catch (e) {
      console.warn('Toto:: ', e);
    }
  }

  private onClickBox() {
    if (this.disabled) { return; }
    this.isDropdownVisible = !this.isDropdownVisible;
    this.$emit('visible', this.isDropdownVisible);
    console.warn(this.isDropdownVisible);
  }

  private onFocus() {
    this.isFocus = true;
  }

  private onBlur() {
    // Commmenting as a fix for missing the click event on workspace context menu
    // this.isFocus = false;
    // this.isDropdownVisible = false;
  }

  private onBlur2() {
    this.isFocus = false;
    this.isDropdownVisible = false;
  }
    // tslint:disable-next-line:no-unused
  private renderDisplayLabels(h: CreateElement) {
    const nodes: VNode[] = [];
    if (this.selectedOptions.length >= 1) {
      const option = this.selectedOptions[0];
      nodes.push(
              <span class = { [`${this.cssPrefix}__label-text`, 'sw-flexbox__flex'] } >
                { option.label }
              </span> as VNode,
            );
    }
    return nodes;
  }

  // tslint:disable-next-line:no-unused
  private renderCheckboxMenuLabels(h: CreateElement) {
    const nodes: VNode[] = [];
    if (this.checkboxmenuLabel) {
      nodes.push(
              <span class = { [`${this.cssPrefix}__label-text`, 'sw-flexbox__flex'] } >
                { this.checkboxmenuLabel }
              </span> as VNode,
            );
    }
    return nodes;
  }

  // tslint:disable-next-line:no-unused
  private renderCheckboxMenu(h: CreateElement): VNode[] {
    let nodes: VNode[] = [];
    nodes = this.options.map((item: any) => {
      return (
        <DropdownLightUnit
          key = { item.id }
          // tslint:disable-next-line:align
          // tslint:disable-next-line:brace-style
          // tslint:disable-next-line:ter-indent
          id = {`${this.cssPrefix}__option-${this.scopeId}-${item.id}`}
          {...{ class: `${this.cssPrefix}__option-${this.scopeId}` }}
          props-theme = { this.theme } >
            {
              <SwCheckbox name="checkboxmenu" props-value={item.value} props-checked={this.productsFilterSelected.includes(item.value)}
                on-change={() => {
                  if (this.productsFilterSelected.includes(item.value)) {
                    this.productsFilterSelected.splice(this.productsFilterSelected.indexOf(item.value), 1);
                  } else {
                    this.productsFilterSelected.push(item.value);
                  }
                  this.$emit('onOptionChecked', this.productsFilterSelected);
                }}>{item.label}</SwCheckbox>
            }
        </DropdownLightUnit>  as VNode
      );
    });
    return nodes;
  }

  // tslint:disable-next-line:no-unused
  private renderThreeDotsMenu(h: CreateElement) {
    if (this.someotherElement) return (<sw-icon name = "arrow-left-thick" size = {10} rotate = {270} color = "#fff"  ></sw-icon>);
    return (<sw-icon name = "more" rotate = {90} ></sw-icon>);
  }

  private renderIcon(h: CreateElement) {
    if (this.someotherElement) return (<sw-icon name = "arrow-left-thick" size = {10} rotate = {270} color = "#fff"  ></sw-icon>);
    try {
      return (<sw-icon name = {this.type} size = {16} ></sw-icon>);
    } catch (e) {
      console.warn('DropdownLight error:', e, h);
    }
  }

    // tslint:disable-next-line:no-unused
  private render(h : CreateElement): VNode {
    // const scrollbarInstance: any = document.getElementsByClassName()
    let rootNode = (<div></div>) as VNode;
    switch (this.type){
      case 'default':
          // tslint:disable-next-line:one-variable-per-declaration
        rootNode = (
            <div
              class = {[`${this.cssPrefix}`, 'sw-typo-default',
                'sw-flexbox', 'sw-flexbox--inline', 'sw-flexbox--center-items',
                {
                  [`${this.cssPrefix}--focus`]: this.isFocus,
                  [`${this.cssPrefix}--disabled`]: this.disabled,
                  [`${this.cssPrefix}--full`]: this.full,
                },
              ]}
            v-dropdown = { this.optionsDropdownValue }
            tabindex = { this.disabled ? undefined : 0 }
            on-click = { this.onClickBox }
            on-focus = { this.onFocus }
            on-blur = { this.onBlur2 }
              // on-keydown={this.onKeydown}
              // on-keyup={this.onKeyup}
            >
                  <div  class = {[`${this.cssPrefix}__label-cont`, 'sw-flexbox__flex',
                    'sw-flexbox', 'sw-flexbox--center-items', 'sw-flexbox--wrap']} >
                      { this.renderDisplayLabels(h) }
                  </div>
                  <div class = { [`${this.cssPrefix}__icon`, { [`${this.cssPrefix}__icon--active`]: this.isDropdownVisible },
                    'sw-flexbox', 'sw-flexbox--center-items', 'sw-flexbox--center-justify']} >
                    <sw-icon name = "arrow-up" size = {10} rotate = { 180 } ></sw-icon>
                  </div>

                </div>
            ) as VNode;
        return rootNode;

      case 'threedotsmenu':
        rootNode = (<div
        v-dropdown = { this.optionsDropdownValue }
        tabindex = { this.disabled ? undefined : 0 }
        on-click = { this.onClickBox }
        on-focus = { this.onFocus }
        on-blur = { this.onBlur }
         style="width:20px; height: 17px; outline: none; margin-right">{this.renderThreeDotsMenu(h)} </div>)as VNode;
        return rootNode;

      case 'checkboxmenu':
        rootNode = (<div
        v-dropdown = { this.checkboxOptionsDropdownValue }
        tabindex = { this.disabled ? undefined : 0 }
        on-click = { this.onClickBox }
        on-focus = { this.onFocus }
        on-blur = { this.onBlur }
        class = {[`${this.cssPrefix}`, 'sw-typo-default',
          'sw-flexbox', 'sw-flexbox--inline', 'sw-flexbox--center-items',
          {
            [`${this.cssPrefix}--focus`]: this.isFocus,
            [`${this.cssPrefix}--disabled`]: this.disabled,
            [`${this.cssPrefix}--full`]: this.full,
          },
        ]}
         style="width:20px; height: 17px; outline: none; margin-right">
          <div  class = {[`${this.cssPrefix}__label-cont`, 'sw-flexbox__flex',
            'sw-flexbox', 'sw-flexbox--center-items', 'sw-flexbox--wrap']} >
              { this.renderCheckboxMenuLabels(h) }
            </div>
            <div class = { [`${this.cssPrefix}__icon`, { [`${this.cssPrefix}__icon--active`]: this.isDropdownVisible },
              'sw-flexbox', 'sw-flexbox--center-items', 'sw-flexbox--center-justify']} >
              <sw-icon name = "arrow-up" size = {10} rotate = { 180 } ></sw-icon>
            </div>
          </div>)as VNode;
        return rootNode;

      default:
        rootNode = (<div
        v-dropdown = { this.optionsDropdownValue }
        tabindex = { this.disabled ? undefined : 0 }
        on-click = { this.onClickBox }
        on-focus = { this.onFocus }
        on-blur = { this.onBlur }
         style="width:20px; height: 17px; outline: none; margin-right">{this.renderIcon(h)} </div>)as VNode;
        return rootNode;

    }
  }
}
